import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import ItermidiateCareUnit from './IntermediateCareUnit';

const ItermidiateCareUnitWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <ItermidiateCareUnit />
        </ServicesChartsDataProvider>
    );
};

export default ItermidiateCareUnitWrapper;
